import { ResultatUpload } from "./resultat-upload";

export class DocumentData {
  utilisateurId?: number;
  createurId!: number;
  entiteId?: number;
  description: string = "";
  nomFichier!:string;
  extension!:string;
  estVisible: boolean = false;
  file?: File;
  resultat!: ResultatUpload;
}
